enum MB_RESOURCE_PICKER_TYPE {
  image = 'image',
  video = 'video',
  anyFile = 'anyFile',
}

interface MB_ResourcePickerResource {
  // We use blob for web but not on mobile. Android is having heap memory issues when trying to convert files to blob.
  blob: Blob | undefined;
  uri: string;
  fileName?: string;
}

const MB_ResourcePickerGetAllowedFileFormats = (resourcePickerType: MB_RESOURCE_PICKER_TYPE) => {
  if (resourcePickerType === MB_RESOURCE_PICKER_TYPE.image) {
    return '.jpeg,.jpg,.png,.jfif,.webp';
  } else if (resourcePickerType === MB_RESOURCE_PICKER_TYPE.video) {
    return '.avi,.mp4,.mov,.wmv,.flv,.mkv,.webm';
  } else if (resourcePickerType === MB_RESOURCE_PICKER_TYPE.anyFile) {
    return undefined;
  } else {
    return undefined;
  }
};

export { MB_RESOURCE_PICKER_TYPE, MB_ResourcePickerGetAllowedFileFormats };
export type { MB_ResourcePickerResource };
